import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

const ProblemSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-slate-50">
      <div className="container px-4 mx-auto">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 mb-6">
              <AlertTriangle className="w-8 h-8 text-orange-500" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Le problème
            </h2>
            <h3 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-6">
              Trop d'entrepreneurs développent avant de valider.
            </h3>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl p-8 md:p-12 shadow-lg"
          >
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Vous avez une idée prometteuse, mais sans preuve, elle reste une intuition.
              Avant de lever des fonds ou d'investir dans un développement complet, il faut montrer que votre concept fonctionne.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              Le prototype, c'est votre première preuve : une version concrète, mesurable et présentable qui teste vos hypothèses et crée la confiance.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;

